














































import { tNewCashback } from '@/store/interfaces/cashback';
import BasicInfo from '@/components/Discount/DiscountBasicInfo.vue';
import Participation from '@/components/Discount/DiscountParticipation.vue';
import Cap from '@/components/Discount/DiscountCap.vue';
import Amount from '@/components/Discount/DiscountAmount.vue';
import DiscountRecurrence from '@/components/Discount/DiscountRecurrence.vue';
import Rules from '@/components/Discount/DiscountRules.vue';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'CashbackForm',
  components: {
    Cap,
    Rules,
    Amount,
    BasicInfo,
    Participation,
    DiscountRecurrence,
  },
  props: {
    success: {
      type: Boolean,
      default: false,
    },
    cashback: {
      type: Object as PropType<tNewCashback>,
    },
  },
  computed: {
    getCashback(): tNewCashback {
      return this.cashback;
    },
  },
  methods: {
    saveCashback(): void {
      this.$emit('cashback', this.getCashback);
    },
  },
  watch: {
    success(sc: boolean): void {
      if (sc) {
        this.$router.push({ name: 'CashbackList', });
      }
    },
  },
});
